import Vue from 'vue'
import dataLabel from './dataLabel.vue'


[
    dataLabel
].forEach(c => {
    Vue.component(c.name, c);
})